<template>
  <v-container class="call-status-row" pa-0 grid-list-md mt-2 :id="id">
    <v-layout row wrap v-if="!isMultiproduct">
      <v-flex :xs12="selectedContactType === -1" :xs11="selectedContactType > -1" class="px-3"> <!-- Flex del contenido -->
        <v-layout class="pt-2">
          <v-flex>
            <v-layout row align-center ml-1>
              <v-btn v-if="!showCallQuality && selectedContactType > -1" class="back-button" @click="goBack" small flat>
                <v-icon>
                  fas fa-angle-left
                </v-icon>
              </v-btn>
              <h2 class="white--text mb-0" :class="{'ml-2': selectedContactType === -1}">
                {{ notification.full_name || notification.name || 'Desconocido' }} - {{ account || 'Sin especificar' }}
              </h2>
              <v-menu
                v-if="!notification.watchlist && notification.customer_id"
                v-model="showCustomerTrackingForm"
                :close-on-content-click="false"
                :nudge-top="380"
                bottom
                offset-y
              >
                <v-btn flat class="ml-3 mt-1 mb-2 customer-tracking-btn" slot="activator">
                  <v-icon color="white" size="18">fa-star</v-icon>
                  <span class="ml-2 text-white">CREAR SEGUIMIENTO</span>
                </v-btn>
                <customer-tracking-form
                  v-model="showCustomerTrackingForm"
                  :customer-id="Number(notification.customer_id)"
                  :customer-name="notification.full_name || notification.name"
                  :customer-account="notification.account"
                  :channel-id="5"
                  :contact="notification.phone"
                  @save="setCustomerTracking(1)"
                />
              </v-menu>
              <customer-tracking-indicator class="ml-3 mt-1 mb-2" v-else-if="notification.watchlist" />
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout v-if="!showCallQuality" class="px-3 mb-3">
          <template v-if="selectedContactType === -1">
            <v-flex v-if="hasMultiproduct">
              <v-btn class="call-status-group text-xs-center white w-100" flat @click="selectedMultiproduct = true">
                <v-layout column>
                  <v-icon medium class="k-orange-linear-text mb-1">
                    payments
                  </v-icon>
                  <span>
                    Multiproducto
                  </span>
                </v-layout>
              </v-btn>
            </v-flex>
            <v-flex v-for="(contactType, i) in contactTypes" :key="`contactType-${i}`" :md2="!hasMultiproduct">
              <v-btn class="call-status-group text-xs-center white w-100" flat @click="selectedContactType = i">
                <v-layout column>
                  <v-icon medium class="k-orange-linear-text mb-1">
                    {{ contactType.icon }}
                  </v-icon>
                  <span>
                    {{ contactType.title }}
                  </span>
                </v-layout>
              </v-btn>
            </v-flex>
          </template>
          <v-flex v-if="selectedContactType >= 1" class="text-xs-center">
            <template v-for="(status, i) in contactTypes[selectedContactType].statuses">
              <v-btn
                v-if="status.name !== 'Sin compromiso'
                  && status.name !== 'Alternativa de pago'
                  && status.name !== 'Intención de pago'
                  && status.name !== 'Llamar luego'
                  && status.name !== 'Recado conocido'
                  && status.name !== 'Recado familiar'
                  && (status.name !== 'Despues de cobranza' || !getDespuesCobranzaSubStatuses().length)"
                :key="`callStatusButton-${i}-simple`"
                class="call-status"
                :class="{'k-orange-linear': selectedStatus === status.id}"
                @click="selectStatusOnly(status.id)"
                flat>
                {{ status.name }}
              </v-btn>
              <v-menu
                v-else-if="status.name === 'Sin compromiso' || status.name === 'Alternativa de pago'"
                :key="`callStatusButton-${i}-menu-sub`"
                small
                top
                offset-y>
                <v-btn
                  slot="activator"
                  class="call-status"
                  :class="{'k-orange-linear': selectedStatus === status.id && subStatus !== ''}"
                  flat>
                  {{ status.name }} {{ selectedStatus === status.id ? `(${subStatus})` : '' }}
                </v-btn>
                <v-list>
                  <v-list-tile
                    v-for="(item, i) in $store.getters.getSubStatusesByStatus(status.id)"
                    :class="{'k-orange-linear': item.name === subStatus}"
                    :key="`subStatus-${i}`"
                    @click="setsubStatus(status.id, item.name)">
                    <v-list-tile-title>
                      {{ item.name }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
              <!-- Recado: status siempre seleccionable; substatus opcional si la compañía los tiene -->
              <v-btn
                v-else-if="isThirdPartyRecadoStatus(status) && !getSubStatusesByStatus(status.id).length"
                :key="`callStatusButton-${i}-recado-simple`"
                class="call-status"
                :class="{'k-orange-linear': selectedStatus === status.id}"
                @click="selectStatusOnly(status.id)"
                flat>
                {{ status.name }}
              </v-btn>
              <v-menu
                v-else-if="isThirdPartyRecadoStatus(status)"
                :key="`callStatusButton-${i}-recado-optional`"
                small
                top
                offset-y>
                <v-btn
                  slot="activator"
                  class="call-status"
                  :class="{'k-orange-linear': selectedStatus === status.id}"
                  @click="selectStatusOnly(status.id)"
                  flat>
                  {{ status.name }}{{ selectedStatus === status.id && subStatus ? ` (${subStatus})` : '' }}
                </v-btn>
                <v-list>
                  <v-list-tile
                    v-for="(item, idx) in getSubStatusesByStatus(status.id)"
                    :class="{'k-orange-linear': item.name === subStatus}"
                    :key="`recado-subStatus-${status.id}-${idx}`"
                    @click="setsubStatus(status.id, item.name)">
                    <v-list-tile-title>
                      {{ item.name }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
              <!-- <v-menu
                v-else-if="status.name === 'Llamar luego'"
                :key="`callStatusButton-${i}`"
                ref="nextContactRef"
                v-model="nextContactMenu"
                :nudge-top="50"
                :return-value.sync="nextContact"
                lazy
                offset-y
                full-width
                class="d-inline-block"
                transition="scale-transition"> -->
              <template v-else-if="status.name === 'Llamar luego' && banNextContact()">
                <v-btn
                  :key="`callStatusButton-${i}-llamar`"
                  slot="activator"
                  class="call-status"
                  :class="{'k-orange-linear': selectedStatus === status.id && nextContact}"
                  flat
                  @click.stop>
                  {{ status.name }} {{ nextContact ? `(${formatDate(nextContact, 'YYYY-MM-DD HH:mm', 'DD/MM/YYYY hh:mm A')})` : '' }}
                  <vue-material-date-time-picker class="custom-datetime" v-model="nextContact" :key="`datetime-${i}`" :is-date-only="false" @click="selectedStatus = status.id"/>
                </v-btn>
                <!-- <datetime
                  v-model="nextContact"
                  :key="`datetime-${i}`"
                  type="datetime"
                  value-zone="America/Santiago"
                  zone="America/Santiago"
                  auto
                  hide-backdrop>
                </datetime> -->
              </template>
                <!-- <v-datetime-picker
                  v-model="nextContact"
                  @input="$refs.nextContactRef[0].save(nextContact)"
                  locale="es"
                  :allowed-dates="allowedDates2"
                  color="k-orange-linear"/> -->
                <!-- <v-text-field
                  v-model="nextContact"
                  color="black"
                  type="time"
                  solo
                  @keyup.enter="nextContactMenu = false"/> -->
              <!-- </v-menu> -->
              <v-menu
                v-else-if="status.name === 'Intención de pago'"
                :key="`callStatusButton-${i}-intencion`"
                ref="datePicker2Ref"
                v-model="datePicker2"
                :nudge-top="50"
                :return-value.sync="paymentIntention"
                lazy
                offset-y
                full-width
                class="d-inline-block"
                transition="scale-transition"
                min-width="290px">
                <v-btn
                  slot="activator"
                  class="call-status"
                  :class="{'k-orange-linear': selectedStatus === status.id && paymentIntention}"
                  @click="selectedStatus = status.id"
                  flat>
                  {{ status.name }} {{ paymentIntention ? `(${formatDate(paymentIntention, 'YYYY-MM-DD', 'DD/MM/YYYY')})` : '' }}
                </v-btn>
                <v-date-picker
                  v-model="paymentIntention"
                  @input="$refs.datePicker2Ref[0].save(paymentIntention)"
                  locale="es"
                  :allowed-dates="allowedDates2"
                  color="k-orange-linear"/>
              </v-menu>
              <v-menu
                v-else-if="status.name === 'Despues de cobranza' && getDespuesCobranzaSubStatuses().length > 0"
                :key="`callStatusButton-${i}-menu-despues-cobranza`"
                v-model="menuDespuesCobranzaOpen"
                small
                top
                offset-y
                @input="onMenuDespuesCobranzaOpen">
                <v-btn
                  slot="activator"
                  class="call-status"
                  :class="{'k-orange-linear': selectedStatus === status.id}"
                  flat>
                  {{ status.name }}{{ selectedStatus === status.id && subStatus ? ` (${subStatus})` : '' }}
                </v-btn>
                <v-list>
                  <v-list-tile
                    v-for="(item, idx) in getDespuesCobranzaSubStatuses()"
                    :class="{'k-orange-linear': item.name === subStatus}"
                    :key="`subStatus-${idx}`"
                    @click="setsubStatus(status.id, item.name)">
                    <v-list-tile-title>
                      {{ item.name }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </template>
          </v-flex>
          <template v-else-if="selectedContactType === 0">
            <v-flex md12>
              <v-layout mb-3 v-if="paymentPromiseSubStatus.length">
                <v-flex class="text-xs-center">
                  <v-btn
                    v-for="(item, i) in paymentPromiseMainSubStatus" :key="`paymentPromiseSubStatus-${i}`"
                    class="call-status"
                    :class="{'k-orange-linear': subStatus === item.name}"
                    @click="subStatus = item.name"
                    flat>
                    {{ item.name }}
                  </v-btn>
                  <v-menu
                    v-if="paymentPromiseMoreSubStatus.length"
                    small
                    top
                    offset-y>
                    <v-btn
                      slot="activator"
                      class="call-status"
                      :class="{'k-orange-linear': isMorePaymentPromiseSubStatusSelected}"
                      flat>
                      Más opciones {{ isMorePaymentPromiseSubStatusSelected ? `(${subStatus})` : '' }}
                    </v-btn>
                    <v-list>
                      <v-list-tile
                        v-for="(item, i) in paymentPromiseMoreSubStatus"
                        :class="{'k-orange-linear': item.name === subStatus}"
                        :key="`paymentPromiseMoreSubStatus-${i}`"
                        @click="subStatus = item.name">
                        <v-list-tile-title>
                          {{ item.name }}
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md2 offset-md4>
                  <v-menu
                    ref="datePicker1Ref"
                    v-model="datePicker1"
                    :nudge-top="50"
                    :return-value.sync="paymentPromise"
                    lazy
                    offset-y
                    full-width
                    class="d-inline-block"
                    transition="scale-transition"
                    min-width="290px">
                    <v-text-field
                      slot="activator"
                      :value="formatDate(paymentPromise, 'YYYY-MM-DD', 'DD/MM/YYYY')"
                      prepend-icon="event"
                      readonly
                      flat
                      solo/>
                    <v-date-picker
                      v-model="paymentPromise"
                      @input="$refs.datePicker1Ref.save(paymentPromise)"
                      locale="es"
                      :allowed-dates="allowedDates"
                      color="k-orange-linear"/>
                  </v-menu>
                </v-flex>
                <v-flex md2 ml-3>
                  <v-text-field
                    v-model.number="paymentPromiseAmount"
                    @keypress="onlyNumbers"
                    color="black"
                    label="Monto compromiso"
                    flat
                    solo/>
                </v-flex>
              </v-layout>
            </v-flex>
          </template>
        </v-layout>
        <v-layout v-if="!showCallQuality && selectedContactType >= 0" row wrap mb-3>
          <v-flex>
            <v-text-field
              v-model="descrip"
              color="black"
              label="Comentario"
              flat
              solo/>
          </v-flex>
        </v-layout>
        <v-layout v-if="showCallQuality" class="mb-3 d-flex justify-center">
          <v-flex v-for="(callQuality, i) in callQualityOptions" :key="`callQuality-${i}`" md2 pr-3>
            <v-btn
              flat
              class="call-status-group text-xs-center white w-100"
              :class="{'k-orange-linear': selectedCallQuality === callQuality.value}"
              @click="selectedCallQuality = callQuality.value">
              <v-layout column>
                <v-icon
                  medium
                  class="k-orange-linear-text mb-1"
                  :class="{'white--text': selectedCallQuality === callQuality.value}">
                  {{ callQuality.icon }}
                </v-icon>
                <span>
                  {{ callQuality.title }}
                </span>
              </v-layout>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="selectedContactType > -1" xs1 class="k-orange-linear text-xs-right">
        <v-btn
          flat
          class="white--text save-button w-100"
          :disabled="buttonDisabled"
          @click="save">
          <v-icon>
            fas fa-save
          </v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs11 class="px-3">
        <v-layout align-center class="pt-2">
          <v-flex class="display-flex" align-center>
            <v-btn class="back-button" @click="goBackMultiproduct" small flat>
              <v-icon small>
                fas fa-angle-left
              </v-icon>
            </v-btn>
            <h3 class="white--text mb-0 ml-2">
              {{ notification.name || 'Desconocido' }} - {{ notification.fiscal_id || notification.account || 'Sin especificar' }}
            </h3>
          </v-flex>
        </v-layout>
        <vue-perfect-scroll class="product-item-container" v-show="!showCallQuality">
          <status-item
            v-for="(product, index) in products"
            :key="`product-item-${index}`"
            :component-id="id"
            :product="product"
            :statuses="statuses"
            :notification="notification">
          </status-item>
        </vue-perfect-scroll>
        <v-layout v-if="showCallQuality" class="mb-3 d-flex justify-center">
          <v-flex v-for="(callQuality, i) in callQualityOptions" :key="`callQuality-${i}`" md2 pr-3>
            <v-btn
              flat
              class="call-status-group text-xs-center white w-100"
              :class="{'k-orange-linear': selectedCallQuality === callQuality.value}"
              @click="selectedCallQuality = callQuality.value">
              <v-layout column>
                <v-icon
                  medium
                  class="k-orange-linear-text mb-1"
                  :class="{'white--text': selectedCallQuality === callQuality.value}">
                  {{ callQuality.icon }}
                </v-icon>
                <span>
                  {{ callQuality.title }}
                </span>
              </v-layout>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs1 class="k-orange-linear text-xs-right">
        <v-btn
          flat
          class="white--text save-button w-100"
          :disabled="!multiproductValidated"
          @click="saveMultiproduct">
          <v-icon>
            fas fa-save
          </v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import EventBus from '@/event-bus';
import VuePerfectScroll from 'vue-perfect-scrollbar';
import permissionsMixin from '@/mixins/permissions';
import statusMixin from '@/mixins/status';
import formatDateMixin from '@/mixins/formatDate';
import VueMaterialDateTimePicker from 'vue-material-date-time-picker';
import StatusItem from './StatusItem';
import CustomerTrackingForm from '@/components/customer/CustomerTrackingForm';
import CustomerTrackingIndicator from '@/components/customer/CustomerTrackingIndicator';

export default {
  mixins: [
    statusMixin,
    formatDateMixin,
    permissionsMixin,
  ],
  components: {
    StatusItem,
    VuePerfectScroll,
    VueMaterialDateTimePicker,
    CustomerTrackingForm,
    CustomerTrackingIndicator,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.paymentPromiseAmount = this.notification.amount;
    if (this.$auth.user().company.multiple_product && this.notification.customer_id) {
      this.axios.get(`customers/products/${this.notification.customer_id}`, {
        params: {
          customer_id: this.notification.customer_id,
        }
      })
        .then(({ data }) => {
          this.products = data.map((item) => {
            const obj = {
              name: item.name,
              reference: item.reference,
              notification_schedule_id: this.notification.id,
              bill_id: item.id,
              product_id: item.product_id,
              status_id: '',
              sub_status_id: '',
              payment_promise: '',
              payment_promise_amount: '',
              descrip: '',
              next_contact: '',
              payment_intention: '',
            };
            return obj;
          });
        });
    }
  },
  data() {
    return {
      disableButton: false,
      nextContactMenu: false,
      datePicker1: false,
      datePicker2: false,
      statusPicker: false,
      menuDespuesCobranzaOpen: false,
      selectedContactType: -1,
      subStatus: '',
      paymentPromise: '',
      paymentIntention: '',
      nextContact: '',
      descrip: '',
      paymentPromiseAmount: 0,
      selectedCallQuality: undefined,
      showCallQuality: false,
      selectedMultiproduct: false,
      callQualityOptions: [
        {
          icon: 'fas fa-phone-slash',
          title: 'Sin conexión',
          value: 1,
        },
        {
          icon: 'fas fa-thumbs-down',
          title: 'Mala',
          value: 2,
        },
        {
          icon: 'fas fa-thumbs-up',
          title: 'Buena',
          value: 3,
        },
      ],
      contactTypes: [
        {
          title: 'Compromiso',
          icon: 'fas fa-calendar',
        },
        {
          title: 'Contacto directo',
          icon: 'fas fa-phone-volume',
          statuses: [
            {
              id: 46,
              name: 'Alternativa de pago',
            },
            {
              id: 44,
              name: 'Intención de pago',
            },
            {
              id: 35,
              name: 'Sin compromiso',
            },
            {
              id: 5,
              name: 'Acepta oferta',
            },
            {
              id: 32,
              name: 'Rechaza oferta',
            },
            {
              id: 37,
              name: 'Llamar luego',
            },
            {
              id: 34,
              name: 'Solicita refinanciamiento',
            },
            {
              id: 26,
              name: 'Cuenta pagada',
            },
            {
              id: 10,
              name: 'Desconoce deuda',
            },
          ],
        },
        {
          title: 'Contacto tercero',
          icon: 'fas fa-people-arrows',
          statuses: [
            {
              id: 31,
              name: 'Recado conocido',
            },
            {
              id: 43,
              name: 'Recado familiar',
            },
          ],
        },
        {
          title: 'Equivocado',
          icon: 'fas fa-user-times',
          statuses: [
            {
              id: 15,
              name: 'Equivocado',
            },
          ],
        },
        {
          title: 'Sin contacto',
          icon: 'fas fa-phone-slash',
          statuses: [
            {
              id: 41,
              name: 'Error interno',
            },
            {
              id: 19,
              name: 'Número no existe',
            },
            {
              id: 6,
              name: 'Buzon de Voz',
            },
          ],
        },
        {
          title: 'Cliente cuelga',
          icon: 'fas fa-microphone-slash',
          statuses: [
            {
              id: 33,
              name: 'Antes de cobranza',
            },
            {
              id: 13,
              name: 'Despues de cobranza',
            },
          ],
        },
      ],
      selectedStatus: -1,
      products: [],
      statuses: [
        // Contacto directo
        {
          id: 8,
          name: 'Compromiso',
        },
        {
          id: 10,
          name: 'Desconoce deuda',
        },
        {
          id: 46,
          name: 'Alternativa de pago',
        },
        {
          id: 44,
          name: 'Intención de pago',
        },
        {
          id: 35,
          name: 'Sin compromiso',
        },
        {
          id: 5,
          name: 'Acepta oferta',
        },
        {
          id: 32,
          name: 'Rechaza oferta',
        },
        {
          id: 37,
          name: 'Llamar luego',
        },
        {
          id: 34,
          name: 'Solicita refinanciamiento',
        },
        {
          id: 26,
          name: 'Cuenta pagada',
        },
        {
          id: 10,
          name: 'Desconoce deuda',
        },
        // Contacto Tercero
        {
          id: 31,
          name: 'Recado conocido',
        },
        {
          id: 43,
          name: 'Recado familiar',
        },
        // Equivocado
        {
          id: 15,
          name: 'Equivocado',
        },
        // Sin contacto
        {
          id: 41,
          name: 'Error interno',
        },
        {
          id: 19, // Invalido
          name: 'Número no existe',
        },
        {
          id: 6,
          name: 'Buzon de voz',
        },
        // Cliente cuelga
        {
          id: 33, // Rechazado
          name: 'Cliente cuelga Antes de cobranza',
        },
        {
          id: 13, // Entregado
          name: 'Cliente cuelga Despues de cobranza',
        },
      ],
      showCustomerTrackingForm: false,
      showTemplate: false,
    };
  },
  computed: {
    ...mapGetters({
      noPaymentReasons: 'noPaymentReasons',
      subStatuses: 'subStatuses',
    }),
    id() {
      return `call-status-${this.notification.id}`;
    },
    isMultiproduct() {
      return this.selectedMultiproduct && this.$auth.user().company.multiple_product;
    },
    hasMultiproduct() {
      return this.products.length && this.$auth.user().company.multiple_product;
    },
    buttonDisabled() {
      return (
        this.disableButton // Si esta variable esta seteada
        || (
          !this.selectedStatus || // O no hay estatus seleccionado
          (
            this.selectedStatus === 8 // O el estatus seleccionado es compromiso
            && (  // Tiene que haber fecha, sub status y monto
              !this.paymentPromise
              || this.subStatus === ''
              || !this.paymentPromiseAmount
            )
          ) || ( // O el estatus seleccionado es proximo contacto, pero tiene que haber fecha
            this.selectedStatus === 37
            && !this.nextContact
          ) || (
            this.selectedStatus === 44 // O el estatus seleccionado es intencion de pago, pero tiene que haber fecha
            && !this.paymentIntention
          ) || ( // O ya estan activos los botones de calidad de la llamada pero no se ha seleccionado nada
            this.showCallQuality
            && this.selectedCallQuality === undefined
          )
        )
      );
    },
    setNoPaymentReason() {
      return this.noPaymentReasons.find(reason => reason.id === this.noPaymentReason).name;
    },
    isReasonSeted() {
      return this.noPaymentReason !== null;
    },
    paymentPromiseSubStatus() {
      const subStatus = this.$store.getters.getSubStatusesByStatus(8);
      if (subStatus.length > 0) {
        subStatus.unshift({
          id: null,
          name: 'Compromiso normal',
        });
      }
      return subStatus;
    },
    // Cantidad de sub status de BD para compromiso (sin contar Compromiso normal).
    paymentPromiseCompanySubStatusCount() {
      return this.$store.getters.getSubStatusesByStatus(8).length;
    },
    // "Más opciones" solo si la compañía supera 6 sub status (aparte de Compromiso normal).
    showPaymentPromiseMoreOptions() {
      return this.paymentPromiseCompanySubStatusCount > 6;
    },
    paymentPromiseMainSubStatus() {
      if (!this.showPaymentPromiseMoreOptions) {
        return this.paymentPromiseSubStatus;
      }
      return this.paymentPromiseSubStatus.filter(item => this.isMainPaymentPromiseSubStatus(item.name));
    },
    paymentPromiseMoreSubStatus() {
      if (!this.showPaymentPromiseMoreOptions) {
        return [];
      }
      return this.paymentPromiseSubStatus.filter(item => !this.isMainPaymentPromiseSubStatus(item.name));
    },
    isMorePaymentPromiseSubStatusSelected() {
      return this.paymentPromiseMoreSubStatus.some(item => item.name === this.subStatus);
    },
    multiproductValidated() {
      const products = this.products.filter(item => item.status_id);
      if (products.length) {
        let valid = true;
        products.forEach((item) => {
          valid = !!item.descrip;
          switch (item.status_id) {
            case 8:
              valid = (this.$store.getters.getSubStatusesByStatus(8).length ? !!item.sub_status_id : true) &&
                !!item.payment_promise &&
                !!item.payment_promise_amount;
              break;
            case 37:
              valid = (this.$store.getters.getSubStatusesByStatus(item.status_id).length ? !!item.sub_status_id : true) &&
                !!item.next_contact;
              break;
            case 44:
              valid = (this.$store.getters.getSubStatusesByStatus(item.status_id).length ? !!item.sub_status_id : true) &&
                !!item.payment_intention;
              break;
            default:
              if (this.$store.getters.getSubStatusesByStatus(item.status_id).length ? !!item.sub_status_id : false) {
                valid = false;
              }
              break;
          }
        });
        return valid;
      }
      return false;
    },
    user() {
      return this.$auth.user();
    },
    canSeeMasked() {
      return this.checkPermissions([
        'see_masked_data',
      ]);
    },
    account() {
      let account = this.notification.fiscal_id || this.notification.account || '';
      if (!this.canSeeMasked && account && !account.includes('*')) {
        const length = account.length - 3;
        const chars = '*'.repeat(length);
        account = `${chars}${account.slice(-3)}`;
      }
      return account;
    },
  },
  methods: {
    banNextContact(){
      // Se quita el 'próximo contacto(llamar luego) para Caja los Andes'
      if(parseInt(this.$auth.user().company_id, 10) === 56746521) {
        return false;
      }
      return true;
    },
    onlyNumbers(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    allowedDates(date) {
      const momentDate = moment(date, 'YYYY-MM-DD');
      const now = moment();
      let check = momentDate.isSameOrAfter(now.format('YYYY-MM-DD'));
      if (this.notification.max_commitment_days) {
        const maxDate = moment().add(parseInt(this.notification.max_commitment_days, 10) - 1, 'days');
        check = check && momentDate.isBefore(maxDate);
      }
      return check;
    },
    allowedDates2(date) {
      return moment(date, 'YYYY-MM-DD').isSameOrAfter(moment().format('YYYY-MM-DD'));
    },
    goBack() {
      this.selectedContactType = -1;
      this.selectedStatus = 0;
      this.paymentPromise = '';
    },
    goBackMultiproduct() {
      this.showCallQuality = false;
      this.selectedCallQuality = false;
      this.selectedMultiproduct = false;
    },
    getSubStatusesByStatus(statusId) {
      return this.$store.getters.getSubStatusesByStatus(statusId) || [];
    },
    getDespuesCobranzaSubStatuses() {
      const excluded = ['Conexion BOT', 'Conexion IVR'];
      return this.getSubStatusesByStatus(13).filter(item => !excluded.includes(item.name));
    },
    isThirdPartyRecadoStatus(status) {
      return status.name === 'Recado conocido' || status.name === 'Recado familiar';
    },
    onMenuDespuesCobranzaOpen(isOpen) {
      if (isOpen) {
        this.selectedStatus = 13;
      }
    },
    // Los sub status de compromiso vienen de la BD por compañía; solo el normal
    // y el de alternativa se muestran como botones fijos, el resto va al menú.
    isMainPaymentPromiseSubStatus(name) {
      const normalized = String(name || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
      return normalized === 'compromiso normal' || normalized.indexOf('alternativ') > -1;
    },
    selectStatusOnly(statusId) {
      this.selectedStatus = statusId;
      this.subStatus = '';
    },
    setsubStatus(statusId, subStatus) {
      this.selectedStatus = statusId;
      this.subStatus = subStatus;
    },
    save() {
      if (this.selectedCallQuality === undefined) {
        this.showCallQuality = true;
      } else {
        this.disableButton = true;
        const timestamp = moment.utc().format('YYYY-MM-DD HH:mm:ss');
        const form = {
          channel_id: 5,
          status: this.statusName[this.selectedStatus],
          user_id: this.$auth.user().id,
          company_id: this.$auth.user().company.id,
          nexus_email: this.$auth.user().nexus_email,
          call_quality: this.selectedCallQuality,
          type_id: Number(this.notification.type_id),
          call_uuid: this.notification.call_uuid,
        };
        if (form.status === 'Compromiso') {
          form.payment_promise = this.paymentPromise;
          form.payment_promise_amount = this.paymentPromiseAmount;
        } else if (form.status === 'Proximo Contacto') {
          form.next_contact = this.nextContact;
        } else if (form.status === 'Intención de pago') {
          form.payment_intention = this.paymentIntention;
        }

        if (this.subStatus) {
          form.sub_status = this.subStatus;
        }
        if (form.status === 'Rechaza oferta') {
          const subStatusList = this.$store.getters.getSubStatusesByStatus(this.selectedStatus);
          if (subStatusList.length) {
            form.sub_status = subStatusList[1].name;
          }
        }

        if (
          form.status === 'Entregado'
          || form.status === 'Compromiso'
          || form.status === 'Rechazado'
          || form.status === 'Sin compromiso'
          || form.status === 'Proximo Contacto'
          || form.status === 'Pagado'
          || form.status === 'Refinanciado'
          || form.status === 'Desconoce deuda'
          || form.status === 'Intención de pago'
          || form.status === 'Acepta oferta'
          || form.status === 'Rechaza oferta'
          || form.status === 'Alternativa de pago'
        ) {
          form.delivered_at = timestamp;
          form.contacted_at = timestamp;
          if (form.status === 'Compromiso') {
            form.payment_promise_at = timestamp;
          } else if (form.status === 'Intención de pago') {
            form.payment_intention_at = timestamp;
          }
        } else if (form.status === 'Equivocado') {
          form.wrong_person_at = timestamp;
        } else if (form.status === 'Rechazado') {
          form.refused_at = timestamp;
        } else if (form.status === 'Buzon de Voz') {
          form.voicemail_at = timestamp;
        } else {
          form.failed_at = timestamp;
        }
        if (this.descrip) {
          form.descrip = this.descrip;
        }

        let url = '';
        if (this.notification.type_id === 7 || this.notification.type_id === 9) {
          url = 'notification_schedules/call_result_inbound';
          // CHANGE_HERE_VOICEMAIL
          if (this.notification.key) {
            form.phone = this.notification.key.phone;
            form.timestamp = this.notification.key.timestamp;
          } else {
            form.phone = this.notification.phone;
            form.timestamp = this.notification.timestamp;
          }
        } else {
          url = 'notification_schedules/call_result';
          form.id = this.notification.id;
        }
        this.axios.post(url, form, {
          timeout: 15000,
        })
          .then(() => {
            this.$store.commit('dialer/REMOVE_CALL_TO_SAVE', this.notification.call_id || this.notification.id);
          })
          .catch(() => {
            EventBus.$emit('modal', 'Ocurrio un error al guardar el estatus, intente nuevamente.');
            this.disableButton = false;
          });
      }
    },
    validatePromise(product) {
      const hasSubStatus = this.$store.getters.getSubStatusesByStatus(8).length ? product.sub_status_id : true;
      return hasSubStatus && product.payment_promise && product.payment_promise_amount && !product.descrip;
    },
    saveMultiproduct() {
      if (!this.selectedCallQuality) {
        this.showCallQuality = true;
      } else {
        let url = '';
        const timestamp = moment.utc().format('YYYY-MM-DD HH:mm:ss');
        const delivered = [
          'Entregado',
          'Compromiso',
          'Rechazado',
          'Sin compromiso',
          'Proximo Contacto',
          'Pagado',
          'Refinanciado',
          'Desconoce deuda',
          'Intención de pago',
          'Acepta oferta',
          'Rechaza oferta',
          'Alternativa de pago',
        ]
        const form = {
          ..._.pick(this.notification, ['account', 'call_id', 'call_quality', 'customer_id', 'id', 'phone', 'type_id']),
          user_id: this.$auth.user().id,
          company_id: this.$auth.user().company.id,
          call_quality: this.selectedCallQuality,
        };
        if (this.notification.type_id === 7 || this.notification.type_id === 9) {
          url = 'multiproduct/ns/call_result_inbound';
          form['phone'] = this.notification.key.phone;
          form['timestamp'] = this.notification.key.timestamp;
        } else {
          url = 'multiproduct/ns/call_result';
          form['id'] = this.notification.id;
        }
        form['products'] = this.products.filter(item => !!item.status_id).map((item) => {
          const obj = {};
          const keys = Object.keys(item);
          for (let i = 0; i < keys.length; i += 1) {
            if (item[keys[i]] && item[keys[i]] !== -1) {
              obj[keys[i]] = item[keys[i]];
            }
            if (delivered.includes(this.statusName[item.status_id])) {
              obj['delivered_at'] = timestamp;
              obj['contacted_at'] = timestamp;
            }
            switch (item.status_id) {
              case 8:
                obj['payment_promise_at'] = timestamp;
                break;
              case 15:
                obj['wrong_person_at'] = timestamp;
                break;
              case 33:
                obj['refused_at'] = timestamp;
                break;
              case 6:
                obj['voicemail_at'] = timestamp;
                break;
              default:
                obj['failed_at'] = timestamp;
                break;
            }
          }
          return obj;
        });
        console.log(form);
        this.axios.post(url, form)
          .catch(() => {})
          .finally(() => {
            console.log('done');
            this.$store.commit('dialer/REMOVE_CALL_TO_SAVE', this.notification.call_id || this.notification.id);
          });
      }
    },
    setCustomerTracking($event) {
      this.$store.commit('dialer/ADD_CALL_TO_SAVE', {
        ...this.notification,
        watchlist: $event,
      });
    },
  },
  watch: {
    selectedContactType() {
      if (this.selectedContactType === 0) {
        this.selectedStatus = 8;
        this.subStatus = null;
        if (!this.paymentPromiseSubStatus.length) {
          setTimeout(() => {
            this.datePicker1 = true;
          }, 300);
        }
      } else {
        this.datePicker1 = false;
        this.selectedStatus = 0;
        this.paymentPromise = '';
        this.descrip = '';
      }
    },
    selectedStatus() {
      if (this.selectedStatus !== 44) {
        this.paymentIntention = '';
      }
      if (this.selectedStatus !== 37) {
        this.nextContact = '';
      }
      if (
        this.selectedStatus !== 35
        && this.selectedStatus !== 46
        && this.selectedStatus !== 8
        && this.selectedStatus !== 13
        && this.selectedStatus !== 31
        && this.selectedStatus !== 43
      ) {
        this.subStatus = '';
      }
      if (this.selectedStatus === 37) {
        // const tmp = document.querySelectorAll('.vmdtp_input');
        // if (tmp.length) {
        //   tmp[0].click();
        // }
        // this.nextContactMenu = true;
      }
    },
  },
};
</script>

<style scoped>
.call-status-row {
  background-color: rgba(38, 50, 56, 0.76) !important;
  transition: background-color .15s ease-in-out;
}
.back-button, .call-status-group, .call-status:not(.k-orange-linear) {
  background-color: #fff !important;
}
.call-status.k-orange-linear {
  background-color: #ff7c64 !important;
}
.call-status-group {
  height: 75px;
  margin: 0;
  padding: 0;
}
.call-status-group.k-orange-linear {
  background-color: #ff7c64 !important;
}
.call-status-group span {
  white-space: initial;
  text-align: center;
}
.back-button {
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
}
.save-button > div {
  display: flex;
  height: 100%;
}
.save-button {
  display: inline-block;
  padding: 0;
  margin: 0;
  height: 100%;
  border: 0;
}
h2 {
  display: inline-block;
}
.custom-datetime >>> .vmdtp_picker {
  top: -25% !important;
}
.custom-datetime >>> .vmdtp_header, .custom-datetime >>> .vmdtp_main__item span.selected, .custom-datetime >>> .vmdtp_header {
  background-color: #ff7c64 !important;
}
.custom-datetime >>> .vmdtp_button {
  color: #ff7c64 !important;
}
.custom-datetime >>> .vmdtp_clock .vmdtp_item, .custom-datetime >>> .vmdtp_button.active {
  background-color: #ff7c64 !important;
  color: #fff !important;
}
.custom-datetime >>> .vmdtp_center-point {
  background-color: #ff7c64 !important;
}
.custom-datetime >>> div.vmdtp_arrow {
  background-color: #ff7c64 !important;
}
.custom-datetime >>> .vmdtp_arrow::before {
  background-color: #ff7c6433 !important;
}
.custom-datetime >>> input.vmdtp_input {
  opacity: 0 !important;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.product-item {
  border-radius: 6px;
  background-color: #fff;
}
.display-flex {
  display: flex;
}
.product-item-container {
  height: 200px;
}

.customer-tracking-btn {
  height: 33px;
  background-color: #758194 !important;
  border: 1px solid #FFFFFF;
}
.template-btn {
  height: 33px;
  background-color: #fff !important;
  border: 1px solid #FFFFFF;
}

.rotated {
  transform: rotate(-45deg);
}

.customer-tracking-btn:hover {
  background-color: #9EAAC1 !important;
  color: #FFFFFF !important;
}

.customer-tracking-form--offset {
  position: absolute;
  right: -400px;
  z-index: 9999;
  top: -340px;
}
</style>



// WEBPACK FOOTER //
// src/components/CallCenter/StatusV2.vue